import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { asyncAddThread } from '../states/threads/action';
import { useInput } from '../hooks/useInput';
import Button from '../components/utilities/Button';
import CustomInput from '../components/utilities/CustomInput';
import CustomLabel from '../components/utilities/CustomLabel';
import CustomTextarea from '../components/utilities/CustomTextarea';

export default function AddNewThreadPage() {
  const dispatch = useDispatch();
  const [title, setTitle] = useInput('');
  const [category, setCategory] = useInput('');
  const [body, setBody] = useInput('');
  const navigate = useNavigate();

  const onSubmitEventHandler = async (event) => {
    event.preventDefault();
    const isSuccess = await dispatch(asyncAddThread({ title, category, body }));
    if (isSuccess) navigate('/');
  };

  const onCancel = () => navigate(-1);

  return (
    <section>
      <h1 className="text-2xl font-bold mb-8">Add New Thread</h1>
      <div className="w-full flex-col gap-x-2">
        <form className="flex flex-col gap-y-6" onSubmit={onSubmitEventHandler}>
          <div className="flex flex-col">
            <CustomLabel htmlFor="title">
              <p>Title</p>
              <CustomInput
                type="text"
                id="title"
                value={title}
                onChange={setTitle}
              />
            </CustomLabel>
          </div>
          <div className="flex flex-col">
            <CustomLabel htmlFor="category">
              <p>Category</p>
              <CustomInput
                type="text"
                id="category"
                value={category}
                onChange={setCategory}
              />
            </CustomLabel>
          </div>
          <div className="flex flex-col">
            <CustomLabel htmlFor="content">
              <p className="-mb-6">Body</p>
              <CustomTextarea id="content" value={body} onChange={setBody} />
            </CustomLabel>
          </div>
          <div className="flex flex-col md:flex-row-reverse gap-4">
            <Button label="Create" isSubmit />
            <Button label="Cancel" variant="tertiary" onClick={onCancel} />
          </div>
        </form>
      </div>
    </section>
  );
}
